import React, { forwardRef, HTMLAttributes } from "react";
import { Calendar1 } from "lucide-react";

interface DateInputProps extends HTMLAttributes<HTMLInputElement> {
  value?: string;
  onClick?: () => void;
  placeholder?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const DateInputWithIcon = forwardRef<HTMLInputElement, DateInputProps>(
  ({ value, onClick, placeholder, onChange, ...rest }, ref) => (
    <div className="date-input-wrapper">
      <input
        {...rest}
        ref={ref}
        className="cqi-form-ddd-due-date form-control"
        onClick={onClick}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      />
      <Calendar1 className="date-input-icon" />
    </div>
  )
);
DateInputWithIcon.displayName = "DateInputWithIcon";